﻿export const toUrlFriendlyName = (value: string) => value?.toLowerCase().replace(/[^a-zæøå0-9]/g, '-')
  .replaceAll('æ', 'ae')
  .replaceAll('ø', 'oe')
  .replaceAll('å', 'aa');